import { Component, EventEmitter, ViewContainerRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentFactory } from 'src/app/@core/services/ComponentFactory/component-factory.service';
import { SidebarService } from '../../../sidebar/data-access/sidebar.service';
import { filter, map, switchMap, tap } from 'rxjs';
import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { EditPropertyComponent } from '../edit-property/edit-property.component';
import { PropertiesService } from '../../data-access/properties.service';
import { MapService } from 'src/app/map/data-access/map.service';
import { Union } from 'src/app/shared/helpers/transformations';
import { Feature } from 'ol';
import { SelectPropertyCadastreOverlayComponent } from '../select-property-cadastre-overlay/select-property-cadastre-overlay.component';
import { ModalService } from 'src/app/@core/services/modal/modal.service';
import { ToastService } from 'src/app/@core/services/toast/toast.service';
import { CreatePropertyEvent, DigitizePropertyOverlayComponent } from '../digitize-property-overlay/digitize-property-overlay.component';
@Component({
  selector: 'app-create-property',
  standalone: true,
  imports: [CommonModule, DigitizePropertyOverlayComponent,DialogModule],
  templateUrl: './create-property.component.html',
  styleUrl: './create-property.component.css'
})
export class CreatePropertyComponent {


  private readonly componentFactoryService: ComponentFactory = inject(ComponentFactory);

  private readonly sidebarService: SidebarService = inject(SidebarService);

  private readonly toastService: ToastService = inject(ToastService);

  private readonly propertiesService: PropertiesService = inject(PropertiesService)

  private readonly modalService: ModalService = inject(ModalService);


  private viewContainerRef: ViewContainerRef = inject(ViewContainerRef)


  createFromCadaster() {

    this.sidebarService.close();

    let component = this.componentFactoryService.appendComponentToBody(SelectPropertyCadastreOverlayComponent);

    this.handleCreateEvent(component,component.instance.createEvent);

  }


  private handleCreateEvent(component, event: EventEmitter<CreatePropertyEvent>)
  {
    event.pipe(
      switchMap(event =>
        this.modalService.showConfirmation(event.create ? "Are you sure you want to create this property?" : "Are you sure you want to cancel?").pipe(
          map(confirmed => ({ confirmed, event }))
        )
      ),
      tap(({ confirmed, event }) => {


        // if no and its not create
        if (!confirmed && !event.create) {
          return;
        }
        else if (confirmed && !event.create) {
          component.destroy();
          this.sidebarService.open();
          return;
        }


        component.destroy();
        this.sidebarService.open();
        this.createProperty(event.feature);


      })
    ).subscribe();
  }



  createByDigitize()
  {
   let component = this.componentFactoryService.appendComponentToBody(DigitizePropertyOverlayComponent);

   this.sidebarService.close();

  this.handleCreateEvent(component,component.instance.createEvent);
  }

  private createProperty(feature)
  {
    this.propertiesService.create(feature).pipe(tap(() => this.toastService.showSuccess("Property Created!")),
      switchMap(propertyID => this.propertiesService.get(propertyID).pipe(map(property => ({propertyID, property})))),
      switchMap(({propertyID, property}) => this.propertiesService.editProperty(property).pipe(map(result => ({propertyID, result})))),
      filter(({propertyID,result}) => result.update),
      switchMap(({propertyID,result}) => this.propertiesService.update(propertyID,result.model))
      ).subscribe();

  }

}
